import Vue from 'vue'
import enquire from 'enquire.js'
import Plugin from './plugin'

Vue.use(Plugin, enquire)



// WEBPACK FOOTER //
// ./src/configs/enquirejs/index.js